import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

export function getButtonComponent(href, to) {
  if (href) return 'a';
  if (to) return Link;
  return 'button';
}

const ButtonText = React.forwardRef(
  ({ to, href, muted, underlined, weight, styles: customStyles, ...props }, ref) => {
    const ButtonTag = getButtonComponent(href, to);
    const target = href && '_blank';

    return (
      <ButtonTag
        className={classnames(
          styles.buttonText,
          { [styles.underlined]: underlined },
          { [styles.regular]: weight === 'regular' },
          { [styles.medium]: weight === 'medium' },
          { [styles.muted]: muted },
          ...customStyles
        )}
        to={to}
        href={href}
        target={target}
        ref={ref}
        {...props}
      />
    );
  }
);

ButtonText.displayName = 'ButtonText';

ButtonText.propTypes = {
  href: PropTypes.string,
  to: PropTypes.string,
  onClick: PropTypes.func,
  underlined: PropTypes.bool,
  weight: PropTypes.oneOf(['regular', 'medium', 'bold']),
  muted: PropTypes.bool,
  styles: PropTypes.array
};

ButtonText.defaultProps = {
  href: null,
  to: null,
  onClick: null,
  underlined: false,
  weight: 'bold',
  muted: false,
  styles: []
};

export default ButtonText;
